export const STORAGE_KEY_RULES = "embersrpgvault-rules";

export const baseState = {
  all: [],
  current: {}
};

if (localStorage.getItem(STORAGE_KEY_RULES)) {
  let storage = JSON.parse(localStorage.getItem(STORAGE_KEY_RULES));

  if (storage) {
    if (storage.all) {
      baseState.all = storage.all;
    }
    if (storage.current) {
      baseState.current = storage.current;
    }
  }
}

export const state = baseState;
